/* eslint-disable @typescript-eslint/no-var-requires */

// Basic I18n data modules
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import { quartzConfig } from 'quartz-config/evaluable';
export const i18nSetup = () => {
  if ( /* quartzConfig.i18n && 'includeAllTimezones' in quartzConfig.i18n && quartzConfig.i18n.includeAllTimezones */false) {
    require('I18n/init/data/allTimezones');
  }
  if ( /* quartzConfig.i18n && 'mode' in quartzConfig.i18n && quartzConfig.i18n.mode === 'sync' */true) {
    return require('i2l?mode=sync!$host-package-base-dir/lang/en.lyaml').default;
  } else if ( /* quartzConfig.i18n && 'mode' in quartzConfig.i18n && quartzConfig.i18n.mode === 'very-lazy' */false) {
    return require('i2l?mode=very-lazy!$host-package-base-dir/lang/en.lyaml').default;
  } else {
    return require('i2l?mode=lazy!$host-package-base-dir/lang/en.lyaml').default;
  }
};